import { useMemo } from 'react';
import type { PersistentDebugLogger } from '@/hooks/telemetry/use-persistent-debug-logger';
import {
  MobileModalDebugShell,
} from '@/hooks/telemetry/mobile-modal-debug';
import { useMobileModalDomProbe } from '@/hooks/telemetry/use-mobile-modal-dom-probe';
import type { Viewport } from '@/theme/breakpoints';
import { buildCstretchmodalDebugState } from './cstretchmodalModel';
import { useCstretchmodalStateTransitionLog } from './useCstretchmodalStateTransitionLog';

interface UseCstretchmodalDebugTelemetryInput {
  canClose: boolean;
  compactAsMobile: boolean;
  debugContext?: Record<string, unknown>;
  debugLogger: PersistentDebugLogger;
  debugName?: string;
  isCompact: boolean;
  isMobile: boolean;
  isTop: boolean;
  modalId: string;
  overlayPortalTargetId?: string;
  showBackButton: boolean;
  useMobileStyling: boolean;
  viewport?: Viewport | null;
  visible: boolean;
}

export function useCstretchmodalDebugTelemetry({
  canClose,
  compactAsMobile,
  debugContext,
  debugLogger,
  debugName,
  isCompact,
  isMobile,
  isTop,
  modalId,
  overlayPortalTargetId,
  showBackButton,
  useMobileStyling,
  viewport,
  visible,
}: UseCstretchmodalDebugTelemetryInput): void {
  const debugState = useMemo<Record<string, unknown>>(() => buildCstretchmodalDebugState({
    debugName,
    visible,
    canClose,
    isTop,
    viewport,
    isMobile,
    isCompact,
    compactAsMobile,
    useMobileStyling,
    overlayPortalTargetId,
    showBackButton,
    debugContext,
  }), [
    canClose,
    compactAsMobile,
    debugContext,
    debugName,
    isCompact,
    isMobile,
    isTop,
    overlayPortalTargetId,
    showBackButton,
    useMobileStyling,
    viewport,
    visible,
  ]);

  useMobileModalDomProbe({
    debugName,
    isTop,
    logger: debugLogger,
    modalId,
    shell: MobileModalDebugShell.Stretch,
    state: debugState,
    visible,
  });

  useCstretchmodalStateTransitionLog({
    debugLogger,
    debugName,
    debugState,
  });
}
